import React from 'react'
import Layout from '../../components/layout/Layout'
import DataTable from 'react-data-table-component';
import { collectionContribuciones, columns } from '../../directories/contribuciones';
import { paginationOptions } from '../../directories/collections';
const ContribucionesView = () => {
    return (
        <Layout>
            <DataTable
                className='dt_contri'
                fixedHeader
                columns={columns}
                data={collectionContribuciones}
                pagination
                paginationComponentOptions={paginationOptions}
            />
        </Layout>
    )
}

export default ContribucionesView
